<svelte:options
  customElement={{
    tag: 'teo-sidenav',
    extend: extendWithStyles,
  }}
/>

<script lang="ts" module>
  import type { TeoCore } from '@/teoCore/TeoCore';
  import { SideNav } from '@/ui/components/navigation';
  import { TeoProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';
</script>

<script lang="ts">
  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <SideNav />
</TeoProvider>
